export enum ProductCode {
  ACCIDENTS = 'accidents',
  CASCO = 'casco',
  CMR = 'cmr',
  GREEN_CARD = 'green_card',
  MEDICAL_TRAVEL = 'medical_travel',
  PROPERTY = 'property',
  RCA = 'rca',
  FINANCIAL = 'financial'
}
